// extracted by mini-css-extract-plugin
export default {"customTooltipContainer":"CustomTooltip_customTooltipContainer__gq7cy","wrapper":"CustomTooltip_wrapper__et3ss","colorBox":"CustomTooltip_colorBox__T5R7+"};